import { SIZE_SMALL as A, SIZE_MEDIUM as R, SIZE_LARGE as E, SIZE_EXTRA_LARGE as I, SIZE_EXTRA_LARGE_2 as _, BREAKPOINT_EXTRA_SMALL as T, BREAKPOINT_SMALL as N, BREAKPOINT_MEDIUM as L, BREAKPOINT_LARGE as t, BREAKPOINT_EXTRA_LARGE as S, BREAKPOINT_EXTRA_LARGE_2 as M, VARIANT_PRIMARY as O, VARIANT_SECONDARY as r, VARIANT_SUCCESS as G, VARIANT_DANGER as o, VARIANT_WARNING as e, VARIANT_INFO as s, VARIANT_LIGHT as n, VARIANT_DARK as P, VARIANT_LINK as D, FORM_TYPE_CONTROL as K, FORM_TYPE_SELECT as V } from "../constants/bootstrapContants.js";
const X = {
  SMALL: A,
  MEDIUM: R,
  LARGE: E,
  EXTRA_LARGE: I,
  EXTRA_LARGE_2: _
}, B = {
  XS: T,
  SM: N,
  MD: L,
  LG: t,
  XL: S,
  XXL: M
}, a = {
  PRIMARY: O,
  SECONDARY: r,
  SUCCESS: G,
  DANGER: o,
  WARNING: e,
  INFO: s,
  LIGHT: n,
  DARK: P,
  LINK: D
}, C = [K, V];
class i {
  getSizes() {
    return { ...X };
  }
  getVariants() {
    return { ...a };
  }
  getWindowBreakpoints() {
    return { ...B };
  }
  getFormTypes() {
    return [...C];
  }
}
const c = new i();
export {
  c as default
};
